import React, { useEffect } from 'react';
import { Trans } from '@lingui/macro';
import { connect } from 'dva';
import { createStructuredSelector } from 'reselect';
import { Heading } from '@mos-cat/typography';
import { Step } from '@mos-front-components/public/es/components/Steps';
import { StepProps } from '@mos-front-components/public/es/components/Steps/private/Step/Step';

import MarriageInfo from '../MarriageInfo/MarriageInfo';
import LiveTogether from '../LiveTogether/LiveTogether';
import { Applicant } from '../Applicant/Applicant';
import Link from '../../shared/Link/Link';
import { ApplicantNameChange } from '../Applicant/ApplicantNameChange';
import ApplicantDocument from '../ApplicantDocument/ApplicantDocument';
import ApplicantAddress from '../ApplicantAddress/ApplicantAddress';
import { validators } from '../../../validators';
import { useStepCompleteSendStats } from '../../../helpers/stats';
import { isStatsSending } from '../../../selectors/submit';
import { sendCMAFormStepChange } from '../../../helpers/CMAstats';

interface Props {
  step?: StepProps;
  stepCompleted: boolean;
  isStatsSending: boolean;
}

function ApplicantData({
  step,
  stepCompleted,
  isStatsSending,
}: Props): JSX.Element {
  useStepCompleteSendStats(isStatsSending, stepCompleted, {
    stepNumber: 1,
    stepTitle: 'Сведения о заявителе',
    childrenCount: null,
  });

  useEffect(() => {
    sendCMAFormStepChange();
  }, []);

  return (
    <Step
      className="FormPage__Step"
      step={step}
      completed={stepCompleted}
      title={
        <Heading level={2} className="FormSteps__StepTitle">
          <Trans>Сведения о заявителе</Trans>
        </Heading>
      }
    >
      <div className="Form__Row">
        <div className="StepContentBlock StepContentBlock_noMarginBottom">
          <Applicant />
          <ApplicantDocument />
        </div>

        <div className="Form__Aside">
          <div className="Content__sub">
            <p className="Content__subText">
              Данные о заявителе заполняются из личного кабинета.
            </p>
            <p className="Content__subText">
              <Trans>
                <Link target="_blank" href="https://my.mos.ru/my/#profile">
                  Отредактируйте профиль
                </Link>
                , если вы хотите изменить их.
              </Trans>
            </p>
          </div>
        </div>
      </div>
      <Heading level={3} className="PguFormGrid__row">
        <Trans>Адрес регистрации по месту жительства (по паспорту)</Trans>
      </Heading>
      <ApplicantAddress />
      <MarriageInfo />
      <LiveTogether />
      <ApplicantNameChange />
    </Step>
  );
}

const mapStateToProps = createStructuredSelector({
  stepCompleted: validators.applicantStepCompleted,
  isStatsSending,
});

export default connect(mapStateToProps)(ApplicantData);
